export const DEFAULT_ITEM_PER_PAGE = 15;
export const DEFAULT_PAGE_NUMBER = 1;
export const PER_PAGE_ARRAY = [
  { id: 15, name: 15 },
  { id: 25, name: 25 },
  { id: 50, name: 50 },
  { id: 100, name: 100 },
];
export const PAGINATED_TABLE_DEFAULT_ITEM_PER_PAGE = 10;
